module.exports = __webpack_public_path__ + "4c98d0b2fa9fdd54135c688cc63e0f48.svg";